import { render, staticRenderFns } from "./contacto.vue?vue&type=template&id=f1103cde&scoped=true"
import script from "./contacto.vue?vue&type=script&lang=js"
export * from "./contacto.vue?vue&type=script&lang=js"
import style0 from "./contacto.vue?vue&type=style&index=0&id=f1103cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1103cde",
  null
  
)

export default component.exports